/**
 * #widgets_svc.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Empty } from "../../../../google/protobuf/empty.js";
import { AddButtonWidgetRequest, AddCalendarWidgetRequest, AddCommunityListWidgetRequest, AddCustomWidgetRequest, AddImageWidgetRequest, AddPostFlairWidgetRequest, AddTextAreaWidgetRequest, ButtonWidget, CalendarWidget, CommunityListWidget, CustomWidget, DeleteWidgetRequest, GetWidgetImageUploadLeaseRequest, GetWidgetImageUploadLeaseResponse, GetWidgetsRequest, GetWidgetsResponse, ImageWidget, OrderWidgetsRequest, PostFlairWidget, TextAreaWidget, UpdateButtonWidgetRequest, UpdateCalendarWidgetRequest, UpdateCommunityListWidgetRequest, UpdateCommunityListWidgetResponse, UpdateCustomWidgetRequest, UpdateImageWidgetRequest, UpdatePostFlairWidgetRequest, UpdateTextAreaWidgetRequest, } from "./widgets_msg.js";
export const WidgetsServiceName = "devvit.plugin.redditapi.widgets.Widgets";
export class WidgetsClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || WidgetsServiceName;
        this.rpc = rpc;
        this.AddButtonWidget = this.AddButtonWidget.bind(this);
        this.AddImageWidget = this.AddImageWidget.bind(this);
        this.AddCalendarWidget = this.AddCalendarWidget.bind(this);
        this.AddTextAreaWidget = this.AddTextAreaWidget.bind(this);
        this.AddCommunityListWidget = this.AddCommunityListWidget.bind(this);
        this.AddPostFlairWidget = this.AddPostFlairWidget.bind(this);
        this.AddCustomWidget = this.AddCustomWidget.bind(this);
        this.DeleteWidget = this.DeleteWidget.bind(this);
        this.UpdateButtonWidget = this.UpdateButtonWidget.bind(this);
        this.UpdateImageWidget = this.UpdateImageWidget.bind(this);
        this.UpdateCalendarWidget = this.UpdateCalendarWidget.bind(this);
        this.UpdateTextAreaWidget = this.UpdateTextAreaWidget.bind(this);
        this.UpdateCommunityListWidget = this.UpdateCommunityListWidget.bind(this);
        this.UpdatePostFlairWidget = this.UpdatePostFlairWidget.bind(this);
        this.UpdateCustomWidget = this.UpdateCustomWidget.bind(this);
        this.GetWidgetImageUploadLease = this.GetWidgetImageUploadLease.bind(this);
        this.OrderWidgets = this.OrderWidgets.bind(this);
        this.GetWidgets = this.GetWidgets.bind(this);
    }
    AddButtonWidget(request, metadata) {
        const data = AddButtonWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AddButtonWidget", data, metadata);
        return promise.then((data) => ButtonWidget.decode(_m0.Reader.create(data)));
    }
    AddImageWidget(request, metadata) {
        const data = AddImageWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AddImageWidget", data, metadata);
        return promise.then((data) => ImageWidget.decode(_m0.Reader.create(data)));
    }
    AddCalendarWidget(request, metadata) {
        const data = AddCalendarWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AddCalendarWidget", data, metadata);
        return promise.then((data) => CalendarWidget.decode(_m0.Reader.create(data)));
    }
    AddTextAreaWidget(request, metadata) {
        const data = AddTextAreaWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AddTextAreaWidget", data, metadata);
        return promise.then((data) => TextAreaWidget.decode(_m0.Reader.create(data)));
    }
    AddCommunityListWidget(request, metadata) {
        const data = AddCommunityListWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AddCommunityListWidget", data, metadata);
        return promise.then((data) => CommunityListWidget.decode(_m0.Reader.create(data)));
    }
    AddPostFlairWidget(request, metadata) {
        const data = AddPostFlairWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AddPostFlairWidget", data, metadata);
        return promise.then((data) => PostFlairWidget.decode(_m0.Reader.create(data)));
    }
    AddCustomWidget(request, metadata) {
        const data = AddCustomWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "AddCustomWidget", data, metadata);
        return promise.then((data) => CustomWidget.decode(_m0.Reader.create(data)));
    }
    DeleteWidget(request, metadata) {
        const data = DeleteWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DeleteWidget", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UpdateButtonWidget(request, metadata) {
        const data = UpdateButtonWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateButtonWidget", data, metadata);
        return promise.then((data) => ButtonWidget.decode(_m0.Reader.create(data)));
    }
    UpdateImageWidget(request, metadata) {
        const data = UpdateImageWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateImageWidget", data, metadata);
        return promise.then((data) => ImageWidget.decode(_m0.Reader.create(data)));
    }
    UpdateCalendarWidget(request, metadata) {
        const data = UpdateCalendarWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateCalendarWidget", data, metadata);
        return promise.then((data) => CalendarWidget.decode(_m0.Reader.create(data)));
    }
    UpdateTextAreaWidget(request, metadata) {
        const data = UpdateTextAreaWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateTextAreaWidget", data, metadata);
        return promise.then((data) => TextAreaWidget.decode(_m0.Reader.create(data)));
    }
    UpdateCommunityListWidget(request, metadata) {
        const data = UpdateCommunityListWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateCommunityListWidget", data, metadata);
        return promise.then((data) => UpdateCommunityListWidgetResponse.decode(_m0.Reader.create(data)));
    }
    UpdatePostFlairWidget(request, metadata) {
        const data = UpdatePostFlairWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdatePostFlairWidget", data, metadata);
        return promise.then((data) => PostFlairWidget.decode(_m0.Reader.create(data)));
    }
    UpdateCustomWidget(request, metadata) {
        const data = UpdateCustomWidgetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateCustomWidget", data, metadata);
        return promise.then((data) => CustomWidget.decode(_m0.Reader.create(data)));
    }
    GetWidgetImageUploadLease(request, metadata) {
        const data = GetWidgetImageUploadLeaseRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetWidgetImageUploadLease", data, metadata);
        return promise.then((data) => GetWidgetImageUploadLeaseResponse.decode(_m0.Reader.create(data)));
    }
    OrderWidgets(request, metadata) {
        const data = OrderWidgetsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "OrderWidgets", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    GetWidgets(request, metadata) {
        const data = GetWidgetsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetWidgets", data, metadata);
        return promise.then((data) => GetWidgetsResponse.decode(_m0.Reader.create(data)));
    }
}
export const WidgetsDefinition = {
    name: "Widgets",
    fullName: "devvit.plugin.redditapi.widgets.Widgets",
    methods: {
        /**
         * Add a button widget to a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_widget}
         */
        addButtonWidget: {
            name: "AddButtonWidget",
            requestType: AddButtonWidgetRequest,
            requestStream: false,
            responseType: ButtonWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            27,
                            18,
                            25,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([8, 42, 6, 98, 117, 116, 116, 111, 110]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Add an image widget to a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_widget}
         */
        addImageWidget: {
            name: "AddImageWidget",
            requestType: AddImageWidgetRequest,
            requestStream: false,
            responseType: ImageWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            27,
                            18,
                            25,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([7, 42, 5, 105, 109, 97, 103, 101]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Add a calendar widget to a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_widget}
         */
        addCalendarWidget: {
            name: "AddCalendarWidget",
            requestType: AddCalendarWidgetRequest,
            requestStream: false,
            responseType: CalendarWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            27,
                            18,
                            25,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([10, 42, 8, 99, 97, 108, 101, 110, 100, 97, 114]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Add a text widget to a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_widget}
         */
        addTextAreaWidget: {
            name: "AddTextAreaWidget",
            requestType: AddTextAreaWidgetRequest,
            requestStream: false,
            responseType: TextAreaWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            27,
                            18,
                            25,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([10, 42, 8, 116, 101, 120, 116, 97, 114, 101, 97]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Add a community list widget to a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_widget}
         */
        addCommunityListWidget: {
            name: "AddCommunityListWidget",
            requestType: AddCommunityListWidgetRequest,
            requestStream: false,
            responseType: CommunityListWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            27,
                            18,
                            25,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([16, 42, 14, 99, 111, 109, 109, 117, 110, 105, 116, 121, 45, 108, 105, 115, 116]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Add a post flair widget to a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_widget}
         */
        addPostFlairWidget: {
            name: "AddPostFlairWidget",
            requestType: AddPostFlairWidgetRequest,
            requestStream: false,
            responseType: PostFlairWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            27,
                            18,
                            25,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([12, 42, 10, 112, 111, 115, 116, 45, 102, 108, 97, 105, 114]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Add a custom widget to a subreddit. This is an experimental feature.
         * Custom widgets don't display on mobile devices. Customizations can break at any time
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_widget}
         */
        addCustomWidget: {
            name: "AddCustomWidget",
            requestType: AddCustomWidgetRequest,
            requestStream: false,
            responseType: CustomWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            27,
                            18,
                            25,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([8, 42, 6, 99, 117, 115, 116, 111, 109]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Delete a widget from a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#DELETE_api_widget_%7Bwidget_id%7D}
         */
        deleteWidget: {
            name: "DeleteWidget",
            requestType: DeleteWidgetRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([8, 10, 6, 68, 69, 76, 69, 84, 69]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            47,
                            123,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update a button widget on a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#PUT_api_widget_%7Bwidget_id%7D}
         */
        updateButtonWidget: {
            name: "UpdateButtonWidget",
            requestType: UpdateButtonWidgetRequest,
            requestStream: false,
            responseType: ButtonWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 80, 85, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            47,
                            123,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([8, 42, 6, 98, 117, 116, 116, 111, 110]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update an image widget on a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#PUT_api_widget_%7Bwidget_id%7D}
         */
        updateImageWidget: {
            name: "UpdateImageWidget",
            requestType: UpdateImageWidgetRequest,
            requestStream: false,
            responseType: ImageWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 80, 85, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            47,
                            123,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([7, 42, 5, 105, 109, 97, 103, 101]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update a calendar widget on a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#PUT_api_widget_%7Bwidget_id%7D}
         */
        updateCalendarWidget: {
            name: "UpdateCalendarWidget",
            requestType: UpdateCalendarWidgetRequest,
            requestStream: false,
            responseType: CalendarWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 80, 85, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            47,
                            123,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([10, 42, 8, 99, 97, 108, 101, 110, 100, 97, 114]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update a text widget on a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#PUT_api_widget_%7Bwidget_id%7D}
         */
        updateTextAreaWidget: {
            name: "UpdateTextAreaWidget",
            requestType: UpdateTextAreaWidgetRequest,
            requestStream: false,
            responseType: TextAreaWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 80, 85, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            47,
                            123,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([10, 42, 8, 116, 101, 120, 116, 97, 114, 101, 97]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update a community list widget on a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#PUT_api_widget_%7Bwidget_id%7D}
         */
        updateCommunityListWidget: {
            name: "UpdateCommunityListWidget",
            requestType: UpdateCommunityListWidgetRequest,
            requestStream: false,
            responseType: UpdateCommunityListWidgetResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 80, 85, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            47,
                            123,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([16, 42, 14, 99, 111, 109, 109, 117, 110, 105, 116, 121, 45, 108, 105, 115, 116]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update a post flair widget on a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#PUT_api_widget_%7Bwidget_id%7D}
         */
        updatePostFlairWidget: {
            name: "UpdatePostFlairWidget",
            requestType: UpdatePostFlairWidgetRequest,
            requestStream: false,
            responseType: PostFlairWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 80, 85, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            47,
                            123,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([12, 42, 10, 112, 111, 115, 116, 45, 102, 108, 97, 105, 114]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update a custom widget on a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#PUT_api_widget_%7Bwidget_id%7D}
         */
        updateCustomWidget: {
            name: "UpdateCustomWidget",
            requestType: UpdateCustomWidgetRequest,
            requestStream: false,
            responseType: CustomWidget,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 80, 85, 84]),
                        new Uint8Array([
                            32,
                            18,
                            30,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            47,
                            123,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 24, 1]),
                        new Uint8Array([8, 42, 6, 99, 117, 115, 116, 111, 109]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Get an S3 upload lease for a widget image. This is used to upload images for image widgets.
         *
         * @see {@link https://www.reddit.com/dev/api#POST_api_widget_image_upload_s3}
         */
        getWidgetImageUploadLease: {
            name: "GetWidgetImageUploadLease",
            requestType: GetWidgetImageUploadLeaseRequest,
            requestStream: false,
            responseType: GetWidgetImageUploadLeaseResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            43,
                            18,
                            41,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            95,
                            105,
                            109,
                            97,
                            103,
                            101,
                            95,
                            117,
                            112,
                            108,
                            111,
                            97,
                            100,
                            95,
                            115,
                            51,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
        /**
         * Update the order of widgets on a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#PATCH_api_widget_order_%7Bsection%7D}
         */
        orderWidgets: {
            name: "OrderWidgets",
            requestType: OrderWidgetsRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {},
        },
        /**
         * Get a list of widgets on a subreddit.
         *
         * @see {@link https://www.reddit.com/dev/api#GET_api_widgets}
         */
        getWidgets: {
            name: "GetWidgets",
            requestType: GetWidgetsRequest,
            requestStream: false,
            responseType: GetWidgetsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            28,
                            18,
                            26,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            97,
                            112,
                            105,
                            47,
                            119,
                            105,
                            100,
                            103,
                            101,
                            116,
                            115,
                        ]),
                        new Uint8Array([11, 58, 9, 115, 117, 98, 114, 101, 100, 100, 105, 116]),
                    ],
                },
            },
        },
    },
};
